import { supabase } from './supabase.js';
import { clearQueryCache } from './query-client.js';

/**
 * Signs out and drops the cached queries, so the next person to sign in on this device never
 * sees what the last one's role could read.
 */
export async function signOut(): Promise<void> {
  try {
    await supabase.auth.signOut();
  } finally {
    clearQueryCache();
  }
}

/**
 * Clears the cache on every sign-out, including one this app did not start: a session that
 * failed to refresh (`clearAuthSession()`) or a sign-out in another tab.
 */
export function clearQueryCacheOnSignOut(): () => void {
  const { data } = supabase.auth.onAuthStateChange((event) => {
    if (event === 'SIGNED_OUT') clearQueryCache();
  });
  return () => data.subscription.unsubscribe();
}
